import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import loadable from '@loadable/component'
import * as Sentry from '@sentry/react'
import dayjs from 'dayjs'
import 'dayjs/locale/sv'
import 'dayjs/locale/fi'

// !! IMOPORTANT  !! These needs to be initialized before any @krea/common import //
import './i18n'
import settings from './settings'
import { setGraphqlClientInCommon } from '@krea/common/graphql'

import '@krea/common/scss/index.scss'
import App from './App'
import Store from './redux'

import { client } from './graphql'

import CookieConsent from '@krea/common/shared-components/cookie-consent'

dayjs.locale('sv')

export const generalStore = Store()

function AppWithCallbackAfterRender() {
	useEffect(() => {
		setGraphqlClientInCommon(client)

		import('./httpService').then((module) => {
			const HttpService = module.default

			const instance = HttpService.getInstance()
			instance.setupInterceptors()
		})

		Sentry.init({
			dsn:
				process.env.REACT_APP_APPLICATION_ENV === 'production'
					? 'https://a9a86248d74b4c7881dec3b30c3ba74a@o242905.ingest.sentry.io/5307143'
					: 'https://e589092f09664e51a15c6c2647b668df@o242905.ingest.sentry.io/5455745',
			environment: process.env.REACT_APP_APPLICATION_ENV,
			enabled: ['production', 'staging'].includes(process.env.REACT_APP_APPLICATION_ENV)
		})

		import('react-gtm-module')
			.then((module) => {
				const TagManager = module.default

				const tagManagerArgs = {
					gtmId: settings.gtmId,
					dataLayer: {
						event: 'initTracking',
						environment: settings.environment
					}
				}

				TagManager.initialize(tagManagerArgs)
			})
			.catch((error) => {
				console.error('Unable to load react-gtm-module')
			})
	}, [])

	return (
		<React.StrictMode>
			<Provider store={generalStore}>
				<App />

				<CookieConsent />
			</Provider>
		</React.StrictMode>
	)
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<AppWithCallbackAfterRender />)
